/* global axios */
import ApiClient from './ApiClient';

class AutomationApprovalRiskMatrixAPI extends ApiClient {
  constructor() {
    super('automation_approval_risk_matrix', { accountScoped: true });
  }

  update(data = {}) {
    return axios.patch(this.url, data);
  }

  replace(data = {}) {
    return axios.put(this.url, data);
  }
}

export default new AutomationApprovalRiskMatrixAPI();
